// import { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import StepIndicator from "../components/modules/newPrototype/StepIndicator";
// import CostEstimator from "../components/modules/newPrototype/CostEstimator";
// import ProjectInfoStep from "../components/modules/newPrototype/ProjectInfoStep";
// import UploadFilesStep from "../components/modules/newPrototype/UploadFilesStep";
// import ManufacturingProcessStep from "../components/modules/newPrototype/ManufacturingProcessStep";
// import SelectCentreStep from "../components/modules/newPrototype/SelectCentreStep";
// import ExpertConsultationStep from "../components/modules/newPrototype/ExpertConsultationStep";
// import ReviewSubmitStep from "../components/modules/newPrototype/ReviewSubmitStep";

// const initialFormData = {
//   projectName: "",
//   expectedQuantity: "",
//   category: "",
//   description: "",
//   targetDeliveryDate: "",
//   files: [],
//   process: "",
//   centre: "",
//   expert: "",
// };

// const TOTAL_STEPS = 4;

// export default function NewPrototype() {
//   const navigate = useNavigate();
//   const [step, setStep] = useState(1);
//   const [formData, setFormData] = useState(initialFormData);

//   const updateField = (field, value) => {
//     setFormData((prev) => ({ ...prev, [field]: value }));
//   };

//   const goNext = () => setStep((s) => Math.min(s + 1, TOTAL_STEPS));
//   const goBack = () => setStep((s) => Math.max(s - 1, 1));

//   const handleSubmit = () => {
//     navigate("/app/dashboard");
//   };

//   const stepComponents = {
//     1: <ProjectInfoStep formData={formData} updateField={updateField} />,
//     2: <UploadFilesStep formData={formData} updateField={updateField} />,
//     3: <ManufacturingProcessStep formData={formData} updateField={updateField} />,
//     // 4: <SelectCentreStep formData={formData} updateField={updateField} />,
//     // 5: <ExpertConsultationStep formData={formData} updateField={updateField} />,
//     4: <ReviewSubmitStep formData={formData} onSubmit={handleSubmit} />,
//   };

//   return (
//     <div>
//       <h1 className="text-3xl font-extrabold text-gray-900">New Prototype Request</h1>
//       <p className="text-gray-600 mt-1 mb-6">6 quick steps to submit your build</p>

//       <StepIndicator currentStep={step} />

//       <div className="grid lg:grid-cols-3 gap-6 items-start">
//         <div className="rounded-xl border bg-card text-card-foreground shadow lg:col-span-2 p-6">
//           {stepComponents[step]}

//           {step < TOTAL_STEPS && (
//             <div className="flex items-center justify-between mt-8 pt-6 border-t border-gray-100">
//               <button
//                 type="button"
//                 onClick={goBack}
//                 disabled={step === 1}
//                 className="text-sm font-semibold px-5 py-2.5 rounded-xl border border-gray-200 text-gray-700 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-50 transition"
//               >
//                 Back
//               </button>
//               <button
//                 type="button"
//                 onClick={goNext}
//                 className="flex items-center gap-2 bg-gradient-to-r from-indigo-600 to-blue-500 text-white text-sm font-semibold px-6 py-2.5 rounded-xl hover:opacity-90 transition"
//               >
//                 Continue →
//               </button>
//             </div>
//           )}
//         </div>

//         <CostEstimator />
//       </div>
//     </div>
//   );
// }




import { useState } from "react";
import { useNavigate } from "react-router-dom";
import StepIndicator from "../components/modules/newPrototype/StepIndicator";
import CostEstimator from "../components/modules/newPrototype/CostEstimator";
import ProjectInfoStep from "../components/modules/newPrototype/ProjectInfoStep";
import UploadFilesStep from "../components/modules/newPrototype/UploadFilesStep";
import ManufacturingProcessStep from "../components/modules/newPrototype/ManufacturingProcessStep";
import ReviewSubmitStep from "../components/modules/newPrototype/ReviewSubmitStep";
import enquiryService from "../service/enquiryService";

const initialFormData = {
  projectName: "",
  requiredQuantity: "",
  shortDescription: "",
  detailedProjectDescription: "",
  productCategory: "",
  industrySector: "",
  developmentStage: "",
  expectedBudgetRange: "",
  targetDeliveryDate: "",
  preferredLocation: "",
  specialRequirements: "",
  additionalNotes: "",
  enquiryFiles: [],
  manufacturingProcesses: [],
  requiredMaterials: [],
  manufacturingRequirements: "",
};

const TOTAL_STEPS = 4;

export default function NewPrototype() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState(initialFormData);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  const updateField = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const goNext = () => setStep((s) => Math.min(s + 1, TOTAL_STEPS));
  const goBack = () => setStep((s) => Math.max(s - 1, 1));

  // NewPrototype.jsx - handleSubmit
  // NewPrototype.jsx - handleSubmit
  // NewPrototype.jsx - handleSubmit
  const handleSubmit = async () => {
    setIsSubmitting(true);
    setError("");

    try {
      const userId = localStorage.getItem('userId');

      if (!userId) {
        setError("User not logged in. Please login again.");
        setIsSubmitting(false);
        return;
      }

      const enquiryData = {
        userId: parseInt(userId),
        projectName: formData.projectName,
        requiredQuantity: parseInt(formData.requiredQuantity) || 0,
        shortDescription: formData.shortDescription || formData.description,
        detailedProjectDescription: formData.detailedProjectDescription || formData.description,
        productCategory: mapProductCategory(formData.category),
        industrySector: mapIndustrySector(formData.industrySector),
        developmentStage: mapDevelopmentStage(formData.developmentStage),
        expectedBudgetRange: mapBudgetRange(formData.expectedBudgetRange),
        targetDeliveryDate: formData.targetDeliveryDate,
        preferredLocation: formData.preferredLocation || "Visakhapatnam",
        specialRequirements: formData.specialRequirements || "",
        additionalNotes: formData.additionalNotes || "",
        enquiryFiles: formData.enquiryFiles?.map(file => file.name) || [], // ✅ Send file names as array
        manufacturingProcesses: mapManufacturingProcesses(formData.manufacturingProcesses || [formData.process]),
        requiredMaterials: mapRequiredMaterials(formData.requiredMaterials || []),
        manufacturingRequirements: formData.manufacturingRequirements || "",
        enquiryStatus: "DRAFT", // ✅ Add this field
      };

      // ✅ If you're sending files separately in FormData, don't include them in the JSON
      // If sending files in JSON, use the above approach
      const files = formData.enquiryFiles || [];
      const response = await enquiryService.createEnquiry(enquiryData, files);

      if (response.id || response.success) {
        navigate("/app/my-enquiries");
      } else {
        setError(response.message || "Failed to submit enquiry.");
      }
    } catch (err) {
      setError(err.message || "An error occurred. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };
  // NewPrototype.jsx - All mapping functions

  const mapProductCategory = (category) => {
    const map = {
      "Electronics": "ELECTRONICS",
      "PCB": "PCB",
      "Robotics": "ROBOTICS",
      "Drone": "DRONE",
      "EV": "EV",
      "Automotive": "AUTOMOTIVE",
      "Aerospace": "AEROSPACE",
      "Medical Device": "MEDICAL_DEVICE",
      "Industrial": "INDUSTRIAL",
      "Consumer": "CONSUMER_PRODUCT",
      "IoT": "IOT",
      "3D Printing": "PRINTING",
      "CNC": "CNC",
      "Injection Moulding": "INJECTION_MOLDING",
    };
    return map[category] || "OTHER";
  };

  const mapIndustrySector = (sector) => {
    const map = {
      "AgriTech": "AGRITECH",
      "Aerospace": "AEROSPACE",
      "Consumer": "CONSUMER",
      "Energy": "ENERGY",
      "Defense": "DEFENSE",
      "Healthcare": "HEALTHCARE",
      "IoT": "IOT",
      "Manufacturing": "MANUFACTURING",
      "Robotics": "ROBOTICS",
      "Logistics": "LOGISTICS",
    };
    return map[sector] || "MANUFACTURING";
  };

  const mapDevelopmentStage = (stage) => {
    const map = {
      "Design": "DESIGN",
      "Working Prototype": "WORKING_PROTOTYPE",
      "Production": "PRODUCTION",
    };
    return map[stage] || "DESIGN";
  };

  // ✅ FIXED: Correct enum values
  const mapBudgetRange = (range) => {
    const map = {
      "Below ₹50,000": "BELOW_50000",
      "₹50,000 - ₹1,00,000": "BETWEEN_50000_AND_100000",
      "₹1,00,000 - ₹5,00,000": "BETWEEN_100000_AND_500000",
      "Above ₹5,00,000": "ABOVE_500000",
    };
    return map[range] || "BELOW_50000";
  };

  // ✅ FIXED: Correct enum values
  const mapManufacturingProcesses = (processes) => {
    const map = {
      "3D Printing": "PRINTING_3D",
      "CNC Machining": "CNC_MACHINING",
      "Laser Cutting": "LASER_CUTTING",
      "Sheet Metal": "SHEET_METAL_FABRICATION",
      "Injection Moulding": "INJECTION_MOLDING",
      "PCB Manufacturing": "ELECTRONICS_PCB",
      "Electronics Assembly": "ELECTRONICS_PCB",
      "Welding": "WELDING_FABRICATION",
      "Robotics": "TOOL_DIE",
      "Composites": "PRODUCT_ASSEMBLY",
    };
    return processes.map(p => map[p] || p).filter(Boolean);
  };

  const mapRequiredMaterials = (materials) => {
    const map = {
      "Plastic": "PLASTIC",
      "Metal": "METAL",
      "Aluminium": "ALUMINIUM",
      "Steel": "STEEL",
      "Stainless Steel": "STAINLESS_STEEL",
      "ABS": "ABS",
      "PLA": "PLA",
    };
    return materials.map(m => map[m] || m).filter(Boolean);
  };

  // NewPrototype.jsx - Update stepComponents
  const stepComponents = {
    1: <ProjectInfoStep formData={formData} updateField={updateField} />,
    2: <UploadFilesStep formData={formData} updateField={updateField} />,
    3: <ManufacturingProcessStep formData={formData} updateField={updateField} />,
    4: <ReviewSubmitStep
      formData={formData}
      onSubmit={handleSubmit}
      onBack={goBack}  // ✅ Pass the goBack function
      isSubmitting={isSubmitting}
      error={error}
    />,
  };

  return (
    <div>
      <h1 className="text-3xl font-extrabold text-gray-900">New Prototype Request</h1>
      <p className="text-gray-600 mt-1 mb-6">4 quick steps to submit your build</p>

      <StepIndicator currentStep={step} />

      <div className="grid lg:grid-cols-3 gap-6 items-start">
        <div className="rounded-xl border bg-card text-card-foreground shadow lg:col-span-2 p-6">
          {stepComponents[step]}

          {step < TOTAL_STEPS && (
            <div className="flex items-center justify-between mt-8 pt-6 border-t border-gray-100">
              <button
                type="button"
                onClick={goBack}
                disabled={step === 1}
                className="text-sm font-semibold px-5 py-2.5 rounded-xl border border-gray-200 text-gray-700 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-50 transition"
              >
                Back
              </button>
              <button
                type="button"
                onClick={goNext}
                className="flex items-center gap-2 bg-gradient-to-r from-indigo-600 to-blue-500 text-white text-sm font-semibold px-6 py-2.5 rounded-xl hover:opacity-90 transition"
              >
                Continue →
              </button>
            </div>
          )}
        </div>

        <CostEstimator />
      </div>
    </div>
  );
}